import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import resolveConfig from 'tailwindcss/resolveConfig';

import twConfig from '../../../tailwind.config.js';

const tailWindConfig = resolveConfig(twConfig);
const tailwindTheme = tailWindConfig?.theme || twConfig.theme;

const colors = Object.fromEntries(
  Object.keys(tailwindTheme.colors || {}).map(key => {
    const colorValue = tailwindTheme.colors[key];
    if (typeof colorValue === 'object') {
      return [key, colorValue];
    }
    return [key, { DEFAULT: colorValue }];
  })
);

const breakpoints = Object.fromEntries(
  Object.keys(tailwindTheme.screens || {}).map(key => [
    key,
    Number(tailwindTheme.screens[key].split('px')[0]),
  ])
);

const breakpointsPx = Object.fromEntries(
  Object.keys(tailwindTheme.screens || {}).map(key => [key, tailwindTheme.screens[key]])
);

const cn = (...inputs) => twMerge(classNames(inputs));

export { breakpoints, breakpointsPx, cn, colors, tailwindTheme };
